module.exports = __webpack_public_path__ + "static/media/EventPhoto1.b7316280.jpg";